var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.rowClass},[_c('AudioRecorderNew',{attrs:{"uploadUrl":_vm.url,"attachmentTypeId":45,"attachmentTypeName":'attachment_type_center_execute',"caption":_vm.generateFileCaption,"isDisabled":!_vm.hasItemPermission(['AUDIO_RECORD'])}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }